import React from "react";
import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { SectionHeading } from "./shared";
import { SERVICES } from "../data";

export const Services = () => {
  return (
    <section id="servicii" className="bg-[#F8F9FA] py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          eyebrow="Servicii"
          title="Servicii complete de contabilitate și fiscalitate"
          subtitle="De la evidența contabilă zilnică până la consultanță strategică, acoperim tot ce are nevoie afacerea ta."
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {SERVICES.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Circle;
            return (
              <motion.a
                key={s.title}
                href="#contact"
                data-testid={`service-card-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                whileHover={{ y: -6 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.45, delay: (i % 5) * 0.06, ease: [0.22, 1, 0.36, 1] }}
                className="group relative rounded-2xl bg-white p-6 shadow-subtle ring-1 ring-black/5 hover:shadow-card transition-shadow duration-300"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-light text-brand group-hover:bg-brand group-hover:text-white transition-colors duration-300">
                  <Icon className="h-6 w-6" strokeWidth={1.75} />
                </span>
                <h3 className="mt-5 text-base font-semibold text-ink">{s.title}</h3>
                <p className="mt-2 text-sm text-ink-muted leading-relaxed">{s.desc}</p>
              </motion.a>
            );
          })}
        </div>
      </div>
    </section>
  );
};
